import { Component, OnDestroy, OnInit } from '@angular/core'
import { Observable, Subscription } from 'rxjs'
import { UsuarioLogin } from './usuario-login'
import {
  UnespCoreAuthService,
  UnespCoreMenuNavigationService,
  UnespCoreUserService,
  UnespCoreUsuario,
} from '@unesp/core'
import { CommonModule } from '@angular/common'
import { Location } from '@angular/common'
import { MatCardModule } from '@angular/material/card'
import { PerfilSelecionarComponent } from './perfil-selecionar/perfil-selecionar.component'
import { FlexLayoutModule } from '@ngbracket/ngx-layout'
import { menu } from 'src/app/menus/menu'
import { ActivatedRoute, Router } from '@angular/router'
import { MatButtonModule } from '@angular/material/button'
import { MenuService } from './menu.service'
import { LocalStorageService } from 'src/app/shared/services/local-storage.service'

@Component({
  selector: 'app-home',
  imports: [CommonModule, MatCardModule, PerfilSelecionarComponent, FlexLayoutModule, MatButtonModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy {
  private userSubscription!: Subscription
  userLogin?: UsuarioLogin | null

  recarregarMenu: number = 0

  private static readonly ROUTE_REDIRECT = 'routeRedirect'
  private static readonly AUTHORIZATION_CODE = 'code'
  private static readonly TRY_AUTH = 'tryAuth'
  navegar = false

  constructor(
    private unespCoreMenuNavigationService: UnespCoreMenuNavigationService,
    private unespCoreAuthService: UnespCoreAuthService,
    private unespCoreUserService: UnespCoreUserService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private menuService: MenuService,
    private localStorageService: LocalStorageService,
    private location: Location
  ) {}

  ngOnInit(): void {
    // Evita bug quando usuário clica no botão voltar do navegador após ter efuado login
    this.location.replaceState('/')

    this.activatedRoute.queryParams.subscribe(params => {
      const authorizationCode = params[HomeComponent.AUTHORIZATION_CODE]
      const routeRedirectParam = params[HomeComponent.ROUTE_REDIRECT]
      if (routeRedirectParam) {
        localStorage.setItem(HomeComponent.ROUTE_REDIRECT, routeRedirectParam)
      }
      if (authorizationCode) {
        this.navegar = true
        this.unespCoreAuthService.retrieveToken(authorizationCode)
      } else {
        const tryAuth = params[HomeComponent.TRY_AUTH]
        if (tryAuth) {
          // Remove valores anteriores
          this.localStorageService.remove('user')
          this.localStorageService.remove('perfil')
          this.localStorageService.remove('identificacaoUsuario')
          this.localStorageService.remove('idAss')
          this.login()
        }
      }
    })
    this.userSubscription = this.unespCoreUserService.user$.subscribe(user => {
      this.userLogin = user as UsuarioLogin
      if (user) {
        this.recarregarMenu = 0
      }
      /**
       * WORKAROUND
       * Reproduzir o problema: login > F5 > logout
       * O menu exibido continua sendo referente ao perfil que o usuário estava logado
       * com apenas os itens com ROLE_WILDCARD_PUBLIC.
       * Solução: recarregar o menu padrão no logout
       */
      if (user == null) {
        this.recarregarMenu += 1
        if (this.recarregarMenu === 1) {
          setTimeout(() => {
            this.unespCoreMenuNavigationService.itensMenuSource.next(menu)
          }, 100)
        }
      }
      if (user && this.navegar) {
        this.navigate()
      }
    })
  }

  get user$(): Observable<UnespCoreUsuario | null> {
    return this.unespCoreUserService.user$
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe()
    }
  }

  login(): void {
    window.location.href = this.unespCoreAuthService.getLoginUrl()
  }

  logout(): void {
    this.unespCoreAuthService.logout('Usuário desconectado com sucesso')
    this.unespCoreMenuNavigationService.appDrawer?.close()
  }

  private navigate() {
    const routeRedirect = this.getRouteRedirect() ?? ''
    localStorage.removeItem(HomeComponent.ROUTE_REDIRECT)
    this.router.navigate([routeRedirect]).then(r => {
      // Recarrega o menu
      let perfilEmCache = this.localStorageService.get('perfil')
      this.menuService.loadMenuPorPerfilNome(perfilEmCache)
      // Abrir e fechar menu para dimensionar corretamente após carregamento de página
      this.unespCoreMenuNavigationService.closeNav()
      this.unespCoreMenuNavigationService.openNav()
    })
  }

  private getRouteRedirect(): string | null {
    return localStorage.getItem(HomeComponent.ROUTE_REDIRECT)
  }
}
